/* Nukbeh */
export const logoPath = '/assets/elite-logo.png';
export const schoolName = 'شركة بيترونكس';
export const isNukbeh = true;
export const usePrintingContract = false;
export const studentData = {
	clothes: true,
}
export const studentDataRequires = {
	previousSchool: true,
}

/* Al Awal */
// export const logoPath = '/assets/al-awal-logo.png';
// export const schoolName = 'مؤسسة الأول التعليمية الخاصة';
// export const isNukbeh = false;
// export const usePrintingContract = false;
// export const studentData = {
// 	clothes: true,
// }
// export const studentDataRequires = {
// 	previousSchool: true,
// }

/* Al Geel Alarabi */
// export const logoPath = '/assets/al-geel-alarabi.png';
// export const schoolName = 'مدرسة الجيل العربي';
// export const isNukbeh = false;
// export const usePrintingContract = true;
// export const studentData = {
// 	clothes: true,
// }
// export const studentDataRequires = {
// 	previousSchool: true,
// }